import styled from 'styled-components';

export const PageWrapper = styled.div`
  padding-bottom: 40px;
`;

export const PageBanner = styled.section`
  background: linear-gradient(135deg, #1A1A1A 0%, #0f0f1a 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  padding: 24px 24px 18px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;

  .page-title {
    font-size: 20px;
    font-weight: 800;
    color: #f1f5f9;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    gap: 10px;
    svg { color: #ff0000; font-size: 20px; }
  }
  .page-sub { font-size: 12.5px; color: #6b7280; }

  .add-video-btn {
    display: flex;
    align-items: center;
    gap: 7px;
    padding: 11px 20px;
    background: #9333EA;
    border: none;
    border-radius: 8px;
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    font-family: inherit;
    flex-shrink: 0;
    align-self: flex-start;
    text-decoration: none;
    transition: background 0.18s, transform 0.15s;

    &:hover { background: #6d28d9; transform: translateY(-1px); }
    svg { font-size: 15px; }
  }
`;

/* ── CONTROLS BAR: search + filters + sort ── */
export const ControlsBar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  background: #111;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  flex-wrap: wrap;

  .search-wrap {
    position: relative;
    width: 200px;
    flex-shrink: 0;

    svg {
      position: absolute;
      inset-inline-start: 10px;
      top: 50%;
      transform: translateY(-50%);
      color: #4b5563;
      font-size: 13px;
      pointer-events: none;
    }

    input {
      width: 100%;
      background: #1A1A1A;
      border: 1px solid rgba(255, 255, 255, 0.08);
      border-radius: 7px;
      padding-block: 8px;
      padding-inline-start: 32px;
      padding-inline-end: 12px;
      color: #e2e8f0;
      font-size: 12.5px;
      font-family: inherit;
      outline: none;
      transition: border-color 0.2s;

      &::placeholder { color: #4b5563; }
      &:focus { border-color: rgba(147, 51, 234, 0.5); }
    }
  }

  .filter-pills {
    display: flex;
    align-items: center;
    gap: 5px;
    flex: 1;
    overflow-x: auto;
    scrollbar-width: none;
    &::-webkit-scrollbar { display: none; }
  }

  .sort-select {
    background: #1A1A1A;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 7px;
    padding: 8px 12px;
    color: #9ca3af;
    font-size: 12px;
    font-family: inherit;
    cursor: pointer;
    outline: none;
    flex-shrink: 0;
    transition: border-color 0.18s;

    &:focus { border-color: rgba(147, 51, 234, 0.5); color: #e2e8f0; }

    option { background: #1A1A1A; }
  }
`;

export const FilterBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 14px;
  border-radius: 20px;
  border: 1px solid ${props => props.active ? '#9333EA' : 'rgba(255,255,255,0.08)'};
  background: ${props => props.active ? 'rgba(147,51,234,0.18)' : 'transparent'};
  color: ${props => props.active ? '#a78bfa' : '#6b7280'};
  font-size: 11.5px;
  font-weight: ${props => props.active ? '600' : '400'};
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
  flex-shrink: 0;
  transition: all 0.16s;

  &:hover { border-color: rgba(147,51,234,0.4); color: #e2e8f0; }
`;

/* 4 columns per row */
export const VideosGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  padding: 16px 20px 4px;

  @media (max-width: 1000px) { grid-template-columns: repeat(3, 1fr); }
  @media (max-width: 720px)  { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 480px)  { grid-template-columns: 1fr; }
`;

export const VideoCard = styled.div`
  background: #1A1A1A;
  border-radius: 9px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.04);
  transition: border-color 0.18s, transform 0.15s, box-shadow 0.18s;

  &:hover {
    border-color: rgba(255, 0, 0, 0.25);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);
    .play-btn { opacity: 1; transform: scale(1); }
  }

  .thumb-wrap {
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;
    background: #0d0d1b;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      transition: transform 0.35s;
    }
    &:hover img { transform: scale(1.05); }

    .play-btn {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.4);
      opacity: 0;
      transform: scale(0.88);
      transition: opacity 0.2s, transform 0.2s;

      svg {
        color: #fff;
        font-size: 40px;
        filter: drop-shadow(0 2px 10px rgba(0,0,0,0.8));
      }
    }

    .duration-badge {
      position: absolute;
      bottom: 6px;
      left: 6px;
      background: rgba(0, 0, 0, 0.85);
      color: #fff;
      font-size: 10px;
      font-weight: 700;
      padding: 2px 6px;
      border-radius: 3px;
      direction: ltr;
    }
  }

  .video-body {
    padding: 9px 10px 10px;
  }

  .video-title {
    font-size: 12px;
    font-weight: 700;
    color: #f1f5f9;
    line-height: 1.45;
    margin-bottom: 8px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-height: 34px;
  }

  .creator-row {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 7px;

    .creator-avatar {
      width: 22px;
      height: 22px;
      border-radius: 50%;
      object-fit: cover;
      background: #2A2A2A;
      border: 1.5px solid rgba(255, 0, 0, 0.4);
      flex-shrink: 0;
    }
    .creator-name {
      font-size: 11px;
      color: #9ca3af;
      flex: 1;
      min-width: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .yt-icon { color: #ff0000; font-size: 13px; flex-shrink: 0; }
  }

  .video-stats {
    display: flex;
    align-items: center;
    gap: 10px;
    direction: ltr;

    .stat {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 10.5px;
      color: #6b7280;
      svg { font-size: 11px; }
    }
  }
`;

/* ── PAGINATION ── */
export const PaginationBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px 4px;
  flex-wrap: wrap;
  gap: 10px;

  .page-info {
    font-size: 12px;
    color: #6b7280;
    span { color: #9ca3af; font-weight: 600; }
  }

  .pages {
    display: flex;
    align-items: center;
    gap: 4px;
    direction: ltr;
  }
`;

export const PageBtn = styled.button`
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border-radius: 7px;
  border: 1px solid ${props => props.active ? '#9333EA' : 'rgba(255,255,255,0.08)'};
  background: ${props => props.active ? '#9333EA' : 'transparent'};
  color: ${props => props.active ? '#fff' : '#9ca3af'};
  font-size: 12.5px;
  font-weight: ${props => props.active ? '700' : '400'};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  opacity: ${props => props.disabled ? 0.3 : 1};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  font-family: inherit;
  transition: all 0.14s;

  svg { font-size: 13px; }

  &:hover:not([disabled]) {
    border-color: rgba(147,51,234,0.5);
    color: #e2e8f0;
    background: ${props => props.active ? '#9333EA' : 'rgba(147,51,234,0.1)'};
  }
`;
